<template>
  <div
    class="card-container"
    :class="`f-${theme}`">
    <div class="card-header">
      <div class="card-header-icon">
        <svgicon :name="`faction/${profile.faction}-small`" />
      </div>
      <div class="card-header-content">
        <div class="title-large nowrap">
          {{ profile.name }}
          <template v-if="!profile.is_active">
            ({{ $t('inactive') }})
          </template>
        </div>
        <div
          v-show="profile.is_dead"
          class="title-small">
          {{ $t('card.profile.dead_player') }}
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="card-illustration">
        <img :src="`data/avatars/${profile.avatar}`" />
      </div>

      <div class="card-information">
        <div class="card-panel-controls">
          <svgicon
            class="card-panel-control"
            name="caret-left"
            @click="movePanelToLeft"
            v-if="leftControl" />
          <div v-else></div>
          <svgicon
            class="card-panel-control"
            name="caret-right"
            @click="movePanelToRight"
            v-if="rightControl" />
          <div v-else></div>
        </div>

        <div class="card-panel-window">
          <div
            ref="panelContainer"
            class="card-panel-container"
            :style="{ left: panelContainerPosition + 'px' }">
            <div class="card-panel">
              <blockquote>
                {{ quote }}
              </blockquote>

              <div
                v-show="profile.full_name"
                class="complex-bonus">
                <div>
                  <strong>{{ profile.full_name }}</strong>
                </div>
              </div>

              <h2 style="margin-top: 62px;">
                {{ $t('card.profile.ranking') }}
              </h2>
              <div class="complex-bonus">
                <div>{{ $t('card.profile.elo') }}</div>
                <div>{{ profile.elo | integer }}</div>
              </div>
            </div>

            <!-- About (long_description) is invisibly suppressed for now:
                 still stored and on the wire, just not shown — restore
                 this panel if players miss it. -->
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="playerId !== profile.id"
      class="card-action">
      <div class="card-action-button">
        <div
          @click="$emit('sendMessage', profile.id)"
          class="button">
          <div>{{ $t('card.profile.contact') }}</div>
        </div>
      </div>
      <div class="card-action-button">
        <div
          @click="toggleChatMute"
          class="button"
          :class="{ 'is-muted': isChatMuted }">
          <div>{{ isChatMuted ? $t('card.profile.unmute_chat') : $t('card.profile.mute_chat') }}</div>
        </div>
      </div>
      <div class="card-action-button">
        <div
          @click="toggleIconMute"
          class="button"
          :class="{ 'is-muted': isIconMuted }">
          <div>{{ isIconMuted ? $t('card.profile.unmute_icons') : $t('card.profile.mute_icons') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardMixin from '@/game/mixins/CardMixin';

export default {
  name: 'profile-card',
  mixins: [CardMixin],
  props: {
    profile: Object,
  },
  computed: {
    quote() { return this.profile.description ? this.profile.description : '—'; },
    playerId() { return this.$store.state.game.player.id; },
    // Per-account mute state. Keyed by profile_id (the cross-game
    // stable identity), stored in Account.settings.muted_{chat,icons}
    // and round-tripped through the existing /accounts/settings
    // endpoint by the portal store's toggleMute mutation.
    isChatMuted() { return this.$store.getters['portal/isChatMuted'](this.profile.id); },
    isIconMuted() { return this.$store.getters['portal/isIconMuted'](this.profile.id); },
  },
  methods: {
    toggleChatMute() {
      this.$store.commit('portal/toggleMute', { kind: 'chat', profileId: this.profile.id });
    },
    toggleIconMute() {
      this.$store.commit('portal/toggleMute', { kind: 'icons', profileId: this.profile.id });
    },
  },
};
</script>
